/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UserPreferencesDto interface.
 */
export function instanceOfUserPreferencesDto(value) {
    let isInstance = true;
    return isInstance;
}
export function UserPreferencesDtoFromJSON(json) {
    return UserPreferencesDtoFromJSONTyped(json, false);
}
export function UserPreferencesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'agreesToMarketing': !exists(json, 'agreesToMarketing') ? undefined : json['agreesToMarketing'],
        'enableEmailNotifications': !exists(json, 'enableEmailNotifications') ? undefined : json['enableEmailNotifications'],
        'enableAdvertisements': !exists(json, 'enableAdvertisements') ? undefined : json['enableAdvertisements'],
    };
}
export function UserPreferencesDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'agreesToMarketing': value.agreesToMarketing,
        'enableEmailNotifications': value.enableEmailNotifications,
        'enableAdvertisements': value.enableAdvertisements,
    };
}
